/**
 * "Finish my plan" for a plan with no option chosen (recorded policies only, or no quotes): an explicit
 * finish, never inferred from seeing no quotes. Hidden once an option is in the plan.
 */
import { Button, Spinner } from '@design-system';
import { useInsuranceFinish } from '../hooks/use-insurance-finish';

export function FinishPlanAction({ clientId }: { clientId: string }) {
  const { canFinishPlan, finishPlan, isFinishing } = useInsuranceFinish(clientId);
  if (!canFinishPlan) return null;

  return (
    <div
      className="flex flex-col items-end gap-1"
      data-testid="consumer-finish-plan"
    >
      <Button
        variant="outline"
        className="rounded-full"
        onClick={() => void finishPlan()}
        disabled={isFinishing}
      >
        {isFinishing && <Spinner />}
        Finish my plan
      </Button>
      <p className="text-muted-foreground text-sm">You can come back and choose a policy later.</p>
    </div>
  );
}
